const formModel = {
    firstName: {
        name: 'firstName',
        label: 'Name*',
        requiredErrorMsg: 'Name is required',
    },
    lastName: {
        name: 'lastName',
        label: 'Surname*',
        requiredErrorMsg: 'Surname is required',
    },
    email: {
        name: 'email',
        label: 'Email*',
        requiredErrorMsg: 'Email is required',
    },
    contactNumber: {
        name: 'contactNumber',
        label: 'Contact Number*',
        requiredErrorMsg: 'Contact Number is required',
    },
    companyName: {
        name: 'companyName',
        label: 'Company Name*',
        requiredErrorMsg: 'Company Name is required',
    },
    role: {
        name: 'role',
        label: 'Role*',
        requiredErrorMsg: 'Please select an option.',
        options: [
            { value: 'Broker', label: 'Broker' },
            { value: 'Managing Agent', label: 'Managing Agent' },
            { value: 'Other', label: 'Other' },
        ],
    },
    roleOther: {
        name: 'roleOther',
        label: 'Role - please specify*',
        requiredErrorMsg: 'Please specify your role',
    },
    dietaryRequirements: {
        name: 'dietaryRequirements',
        label: 'Dietary Requirements*',
        requiredErrorMsg: 'Please select an option.',
        options: [
            { value: 'None', label: 'None' },
            { value: 'Kosher', label: 'Kosher' },
            { value: 'Halaal', label: 'Halaal' },
            { value: 'Other', label: 'Other' },
        ],
    },
    dietaryOther: {
        name: 'dietaryOther',
        label: 'Dietary requirements - please specify*',
        requiredErrorMsg: 'Please specify your dietary requirements',
    },
};

export default formModel;
